import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { SuspensionContext } from '../model/suspension'

/**
 * Пауза окон кабинета: пока на странице открыто своё окно (выбор города,
 * исход регистрации, согласие с политикой), окно отмены/дисквалификации не
 * ложится поверх. Счётчик, а не флаг — окон на странице может быть несколько.
 */
export function ParticipantNoticesProvider({ children }: { children: ReactNode }) {
  const [count, setCount] = useState(0)
  const register = useCallback(() => {
    setCount((n) => n + 1)
    return () => setCount((n) => n - 1)
  }, [])
  const value = useMemo(() => ({ register, suspended: count > 0 }), [register, count])
  return <SuspensionContext.Provider value={value}>{children}</SuspensionContext.Provider>
}
